function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  id: "Group_4762",
  "data-name": "Group 4762",
  xmlns: "http://www.w3.org/2000/svg",
  width: "18",
  height: "16"
}, props), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-path"
}, /*#__PURE__*/React.createElement("path", {
  id: "Rectangle_2001",
  "data-name": "Rectangle 2001",
  fill: "none",
  d: "M0 0h18v20H0z"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_4761",
  "data-name": "Group 4761",
  clipPath: "url(#clip-path)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_2554",
  "data-name": "Path 2554",
  d: "M16 12a1.993 1.993 0 00-1.614.828 5.381 5.381 0 01-.936-.581 11.536 11.536 0 01-2.542-3.566A2 2 0 009.5 5.261a2.057 2.057 0 00-.262.026 10.778 10.778 0 00-1.711-2.2A6.686 6.686 0 005 1.565a5.428 5.428 0 00-1.13-.245 1.989 1.989 0 10.088 1.067 4.572 4.572 0 01.8.193 5.75 5.75 0 012.127 1.31 9.823 9.823 0 011.4 1.789 1.986 1.986 0 001.734 3.5 12.273 12.273 0 002.8 3.878 6.4 6.4 0 001.2.743A1.832 1.832 0 0014 14a2 2 0 102-2",
  fill: "#282828"
}))));